
import {
    loadBannerList,
    insertBanner,
    updateBanner,
    updateActive,
    deleteBanner,
    getBannerListSwap,
    reorderBanner,
    getBannerListBin,
} from "@/service/banner/banner";
import { uploadImage } from "@/service/upload/upload";
import { getUserGroup } from '@/service/account/manageUser';
export default {
    data() {
        return {
            loadingSave: false,

            indexItem: null,
            status_toggle: 0,
            valid: true,
            alert: false,
            isOpen: false,
            imageFile: null,
            imageReady: false,
            imageName: null,
            imgURL: '',
            loading: true,
            searchdata: "",
            sortData: "",
            searchBanner: null,
            pageCount: 1,
            limit: 10,
            imgPreview: null,
            active: false,
            params: {},
            actionEdit: "",
            priority: "",
            preparePreview: "",
            banner: [],
            bannerList: [],
            bannerListBin: [],
            deleteDialog: false,
            dialogStatus: false,
            dialogStatusActive: false,
            dialogActiveSuccess: false,
            dialogOrder: false,
            dialogAddSuccess: false,
            dialogEditSuccess: false,
            enabled: true,
            dialogRecycleBin: false,
            dialogMultiRecoverSuccess: false,
            dialogRecover: false,
            loadingRecover: false,
            dialogFail: false,
            pageCountBin: 0,
            paramsBin: {},
            imgBool: false,
            tempFile: null,

            bannerName: "",
            bannerID: "",
            urlRules: (v) =>
                v.length <= 200 ||
                this.$vuetify.lang.t("$vuetify.bannerManagement.urlRulesLimit"),
            groupRules: [(v) => !!v || 'User Group is Required'],
            url: null,
            arrayUserGroup: [],
            groupUsers: [],
            user_groups: [],
            showUserGroup: null,
            groupValid: false,
        };
    },
    async mounted() {
        await this.initialize();
    },
    computed: {
        pages() {
            if (
                this.pagination.rowsPerPage == null ||
                this.pagination.totalItems == null
            )
                return 0;

            return Math.ceil(
                this.pagination.totalItems / this.pagination.rowsPerPage
            );
        },
        fileRules() {
            const rules = [];

            // insert
            if (this.bannerID === "") {
                const rule = (v) =>
                    !!v || this.$vuetify.lang.t("$vuetify.bannerManagement.fileRules");
                rules.push(rule);
            }
            if (this.bannerID === "") {
                const rule = (v) =>
                    (v && v.size < 20000000) ||
                    this.$vuetify.lang.t("$vuetify.bannerManagement.fileRulesSize");
                rules.push(rule);
            }

            // update
            if (this.bannerID !== "") {
                const rule = (v) =>
                    (v ? (v.size < 20000000 ? true : false) : true) ||
                    this.$vuetify.lang.t("$vuetify.bannerManagement.fileRulesSize");
                rules.push(rule);
            }
            return rules;
        },
        bannerNameRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t("$vuetify.bannerManagement.bannerNameRules"),
                (v) =>
                    (v && v.length <= 100) ||
                    this.$vuetify.lang.t(
                        "$vuetify.bannerManagement.bannerNameRulesLimit"
                    ),
            ];
        },
        headersBin() {
            return [
                {
                    text: this.$vuetify.lang.t("$vuetify.bannerManagement.photo"),
                    align: "center",
                    sortable: false,
                    value: "image",
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.bannerManagement.name"),
                    sortable: false,
                    align: "start",
                    value: "title",
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.bannerManagement.recover"),
                    align: "center",
                    sortable: false,
                    value: "edit",
                },
            ];
        },
        headers() {
            return [
                {
                    text: this.$vuetify.lang.t("$vuetify.bannerManagement.photo"),
                    align: "left",
                    sortable: false,
                    value: "image",
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.bannerManagement.name"),
                    value: "title",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.bannerManagement.createdDate"),
                    value: "date",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.bannerManagement.statusHeader"),
                    value: "active",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.bannerManagement.action"),
                    align: "center",
                    value: "actions",
                    sortable: false,
                },
            ];
        },
    },
    watch: {
        searchdata(keyword) {
            if (this.$store.state.permission.viewBanner) {
                this.searchInfo(keyword);
            } else {
                this.noPermission();
            }
        },
        showUserGroup(value) {
            console.log(value);
            if (value) {
                if (this.user_groups.length == 0 || this.user_groups.length == null) {
                    this.groupValid = false;
                } else if (this.user_groups.length > 0) {
                    this.groupValid = true;
                } else {
                    this.groupValid = false;
                }
            } else if (!value) {
                this.groupValid = true;
            } else {
                this.groupValid = false;
            }
        },
        user_groups(value) {
            console.log(value)
            if (this.showUserGroup == true) {
                if (this.user_groups.length > 0) {
                    this.groupValid = true;
                } else {
                    this.groupValid = false;
                }
            } else {
                this.groupValid = true;
            }
        }

    },
    methods: {
        async initialize() {
            this.params = {
                search: this.searchBanner,
                sort: "priority",
                sortby: -1,
                page: 1,
                limit: 10,
                active: "null",
            };
            this.paramsBin = {
                search: this.searchBanner,
                sort: "priority",
                sortby: -1,
                page: 1,
                limit: 10,
                active: "null",
            };
            this.searchdata = "";
            this.status_toggle = 0;
            this.showUserGroup = false;
            this.groupValid = false;

            if (!this.$store.state.permission.viewBanner) {
                this.noPermission();
            } else {
                await this.getUserGroupList();
                await this.getBannerList();
                this.getBannerListIsTrash();
            }
        },
        searchInfo(keyword) {
            this.params.search = keyword;
            this.params.page = 1;
            this.getBannerList();
        },
        onSort() {
            if (this.$store.state.permission.viewBanner) {
                if (this.status_toggle == 1) {
                    this.params.active = true;
                    this.getBannerList();
                } else if (this.status_toggle == 2) {
                    this.params.active = false;
                    this.getBannerList();
                } else {
                    this.params.active = "null";
                    this.getBannerList();
                }
            } else {
                this.noPermission();
            }
        },
        // async preview() {
        //     if (this.imageFile != null) {
        //         if (this.imageFile.size > 20000000) return;
        //         this.imgURL = await this.uploadImg(this.imageFile);
        //         this.imgPreview = this.imgURL;
        //         this.imageReady = true;
        //     } else {
        //         if (this.preparePreview) {
        //             this.imgPreview = this.preparePreview;
        //             this.imageReady = true;
        //         } else {
        //             this.imageReady = false;
        //         }
        //     }
        // },
        async preview(event) {
            let file = {};
            if (event.target.files[0]) {
                file = event.target.files[0];
                this.imageFile = file;
                this.tempFile = this.imageFile;
                this.imgPreview = await URL.createObjectURL(file);
                this.imageName = file.name;
            } else {
                this.imageFile = this.tempFile;
            }

            if (this.imgPreview) {
                this.imgBool = true;
                this.imageReady = true;
            } else {
                this.imageReady = false;
            }
        },

        refreshFilter() {
            this.initialize();
        },
        async onUpload() {
            let isValidForm = true;
            let isValidImg = true;

            if (this.bannerName.length > 2 && this.bannerName.length <= 50) {
                isValidForm = true;
            } else {
                isValidForm = false;
            }
            if (this.groupValid == true) {
                isValidForm = true;
            } else {
                isValidForm = false;
            }

            if (
                this.imageFile == "" &&
                this.preparePreview == "" &&
                this.imgPreview == null
            ) {
                isValidImg = false;
            } else {
                isValidImg = true;
            }

            if (isValidForm == true && isValidImg == true) {
                await this.insertBanner();
                await this.getBannerList();
            }
        },
        async orderBanner() {
            let result = await getBannerListSwap();
            this.bannerList = [];
            result.forEach((bannerList) => {
                this.bannerList.push({
                    id: bannerList._id,
                    title: bannerList.title,
                    image: bannerList.image,
                    priority: bannerList.priority
                });
            });
            this.dialogOrder = true;
        },
        async closeDialogOrder() {
            this.dialogOrder = false;
            await this.getBannerList();
        },
        async checkMoveBanner() {
            let arrayBannerId = [];
            arrayBannerId = this.bannerList.map((banner) => banner.id);
            await this.reorderBanner(arrayBannerId);
            await this.getBannerList();
        },
        async reorderBanner(banners) {
            await reorderBanner({
                banners: banners,
            });
            await this.getBannerList();
        },
        async getBannerList() {
            this.loading = true;
            let result = await loadBannerList(this.params);
            this.banner = [];
            this.pageCount = result.maxPage;
            result.data.forEach((banner) => {
                this.banner.push({
                    id: banner._id,
                    title: banner.title,
                    image: banner.image,
                    date: banner.created_at,
                    active: banner.active,
                    priority: banner.priority,
                    url: banner.url,
                    user_groups: banner.user_groups,
                });
            });
            this.loading = false;
        },
        async uploadImg(image) {
            let status = await uploadImage("banner", image);
            return status;
        },

        async insertBanner() {
            this.loadingSave = true;

            let tmpUrl = null;
            let item_user_group_id = [];
            if (this.showUserGroup == false) {
                item_user_group_id = [];
            } else {
                if (this.user_groups != null) {
                    if (this.user_groups.length > 0) {
                        this.user_groups.forEach(element => {
                            item_user_group_id.push(element._id)
                        });
                    }
                } else {
                    this.user_groups = [];
                }
            }

            if (this.url) {
                let tempLowerUrl = this.url.toLowerCase()
                let tmphttps = tempLowerUrl.indexOf("http")
                if (tmphttps > -1) {
                    // this.url = this.url.replace("https://", "");
                    // this.url = this.url.replace("http://", "");
                    this.url = this.url.replace(/https:[/][/]/gi, '')
                    this.url = this.url.replace(/http:[/][/]/gi, '')
                }
                tmpUrl = "https://" + this.url;

                // tmpUrl = this.url.replace(/http:/gi, 'https:')
            }
            if (this.actionEdit == "edit") {
                let body = {};
                if (this.imageFile) {
                    this.imgBool = true;
                    this.imgURL = await this.uploadImg(this.imageFile);
                    body = {
                        idbanner: this.bannerID,
                        title: this.bannerName,
                        image: this.imgURL,
                        active: this.bannerActive,
                        priority: this.priority,
                        action: "show_web_view",
                        url: tmpUrl,
                        user_groups: item_user_group_id
                    };

                } else {
                    body = {
                        idbanner: this.bannerID,
                        title: this.bannerName,
                        image: this.preparePreview,
                        active: this.bannerActive,
                        priority: this.priority,
                        url: tmpUrl,
                        action: "show_web_view",
                        user_groups: item_user_group_id
                    };
                }

                let status = await updateBanner(body);
                this.imgBool = false;
                if (status.message == "banner name duplicate") {
                    this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
                    this.bannerName = "";
                } else if (status.code == 403) {
                    this.dialogFail = true; //กรณี error อื่น
                } else {
                    this.dialogEditSuccess = true;
                    this.getBannerList();
                    this.url = null;
                    this.bannerID = "";
                    this.bannerName = "";
                    this.imageFile = null;
                    this.imgPreview = '';
                    this.tempFile = null;
                    this.$refs.form.resetValidation();
                    this.imageReady = false;
                    this.isOpen = false;
                    this.imageName = '';
                    this.user_groups = [];

                }
            } else {
                let statusAdd = "";
                if (this.imageFile == "" || this.imageFile == null) {
                    statusAdd = await insertBanner({
                        title: this.bannerName,
                        image: this.preparePreview,
                        action: "show_web_view",
                        url: tmpUrl,
                        user_groups: item_user_group_id
                    });
                } else {
                    this.imgBool = true;
                    this.imgURL = await this.uploadImg(this.imageFile);
                    statusAdd = await insertBanner({
                        title: this.bannerName,
                        image: this.imgURL,
                        action: "show_web_view",
                        url: tmpUrl,
                        user_groups: item_user_group_id
                    });
                }
                this.imgBool = false;
                if (statusAdd.message == "banner name duplicate") {
                    this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
                    this.bannerName = "";
                } else if (statusAdd.code == 403) {
                    this.dialogFail = true; //กรณี error อื่น
                } else {
                    this.dialogAddSuccess = true;
                    this.getBannerList();

                    this.bannerID = "";
                    this.bannerName = "";
                    this.url = null;
                    this.imageFile = null;
                    this.imgPreview = '';
                    this.$refs.form.resetValidation();
                    this.imageReady = false;
                    this.isOpen = false;
                    this.imageName = '';
                    this.user_groups = [];
                }
            }
            this.loadingSave = false;
        },
        async openRecycleBin() {
            await this.getBannerListIsTrash();
            this.dialogRecycleBin = true;
        },
        async changePageBin(page) {
            this.paramsBin.page = page;
            await this.getBannerListIsTrash();
        },
        closeDialogRecover() {
            this.dialogRecycleBin = false;
        },
        async closeDialogRecycleBin() {
            this.dialogRecycleBin = false;
            await this.getBannerList();
        },
        async getBannerListIsTrash() {
            let result = await getBannerListBin(this.paramsBin);
            this.bannerListBin = [];
            this.pageCountBin = result.maxPage;
            result.data.forEach((banner) => {
                this.bannerListBin.push({
                    id: banner._id,
                    image: banner.image,
                    title: banner.title,
                });
            });
        },
        confirmRecover(item) {
            this.bannerBinItem = item;
            this.dialogRecover = true;
        },
        async recoverBanner() {
            this.loadingRecover = true;
            let status = await deleteBanner({
                idbanner: this.bannerBinItem.id,
                istrash: false,
            });
            if (status.code == 403) {
                this.dialogFail = true;
            } else {
                this.deleteDialog = false;
                this.getBannerList();
            }

            this.loadingRecover = false;
            this.dialogRecover = false;

            this.bannerBinItem = null;
            this.page = 1;
            this.pageCount - 1;
            await this.initialize();
        },

        deleteItem(item) {
            let index = this.banner.indexOf(item);
            let deleteID = this.banner[index];
            this.bannerID = deleteID.id;
            this.deleteDialog = true;
        },

        async confirmDelete() {
            let status = await deleteBanner({
                idbanner: this.bannerID,
                istrash: true,
            });
            if (status.code == 403) {
                this.dialogFail = false;
                this.deleteDialog = false;
            } else {
                this.deleteDialog = false;
                this.getBannerList();
            }
        },

        noPermission() {
            this.alert = true;
        },
        async changePage(page) {
            this.params.page = page;
            await this.getBannerList();
        },
        editItem(item) {
            if (this.$refs.form) {
                console.log(item);
                this.imageReady = false;
                this.bannerID = "";
                this.bannerName = "";
                this.url = null;
                this.imageFile = null;
                this.imgPreview = null;
                this.imgBool = false;
                this.imgURL = "";
                this.imageName = "";
                this.tempFile = null;
                this.preparePreview = "";
                this.actionEdit = "";
                this.user_groups = [];
                this.showUserGroup = false;
                this.groupValid = false;

                this.$refs.form.resetValidation();
            }
            if (item) {
                let index = this.banner.indexOf(item);
                let editBanner = this.banner[index];
                if (editBanner.url) {
                    // editBanner.url = editBanner.url.toLowerCase();
                    // let tmphttps = editBanner.url.indexOf("http");
                    // if (tmphttps > -1) {
                    //     editBanner.url = editBanner.url.replace("https://", "");
                    //     editBanner.url = editBanner.url.replace("http://", "");
                    // }
                    // editBanner.url = editBanner.url.replace(/http:[/][/]/gi, '')
                    // editBanner.url = editBanner.url.replace(/https:[/][/]/gi, '')
                    let tempLowerUrl = editBanner.url.toLowerCase()
                    let tmphttps = tempLowerUrl.indexOf("http")
                    if (tmphttps > -1) {
                        editBanner.url = editBanner.url.replace(/https:[/][/]/gi, '')
                        editBanner.url = editBanner.url.replace(/http:[/][/]/gi, '')
                    }
                }
                if (editBanner.user_groups != null) {
                    if (editBanner.user_groups.length > 0) {
                        this.showUserGroup = true;
                    } else {
                        this.showUserGroup = false;
                    }
                } else {
                    this.showUserGroup = false;
                    this.user_groups = [];

                }
                this.bannerID = editBanner.id;
                this.bannerName = editBanner.title;
                this.imgPreview = editBanner.image;
                this.preparePreview = editBanner.image; //valid image
                this.bannerActive = editBanner.active;
                this.priority = editBanner.priority;
                this.url = editBanner.url;
                if (this.imgPreview) {
                    this.imgBool = true;
                }
                this.actionEdit = "edit";

                this.user_groups = editBanner.user_groups;
                let items = [];
                let itemLists = [];
                if (editBanner.user_groups != null) {
                    editBanner.user_groups.forEach(element => {
                        items = [];
                        items = this.arrayUserGroup.filter((group) => {
                            return group._id == element
                        });
                        if (items.length > 0) {
                            itemLists.push(items[0]);
                        }
                    });
                    this.user_groups = itemLists;
                } else {
                    this.user_groups = [];
                }

            }
            this.isOpen = true;
        },
        closeDialog() {
            this.imageReady = false;
            this.bannerID = "";
            this.bannerName = "";
            this.url = null;
            this.imageFile = null;
            this.imgPreview = null;
            this.imgBool = false;
            this.imgURL = "";
            this.imageName = "";
            this.tempFile = null;
            this.preparePreview = "";
            this.actionEdit = "";
            this.showUserGroup = false;
            this.groupValid = false;
            this.user_groups = [];
            this.$refs.form.resetValidation();

            this.isOpen = false;
        },
        openModalStatus(item) {
            let index = this.banner.indexOf(item);
            this.indexItem = index;
            if (this.banner[index].active == true) {
                this.dialogStatus = true;
                this.updateActiveId = this.banner[index].id;
                this.updateActive = this.banner[index].active;
            } else {
                this.dialogStatusActive = true;
                this.updateActiveId = this.banner[index].id;
                this.updateActive = this.banner[index].active;
            }
        },
        async updateActiveBanner() {
            if (this.updateActive == true) {
                let status = await updateActive({
                    id: this.updateActiveId,
                    active: false,
                });
                this.getBannerList();
                if (status.code == 403) {
                    this.dialogFail = true;
                    this.dialogStatus = false;
                } else {
                    this.dialogActiveSuccess = true;
                    this.dialogStatus = false;
                    this.getBannerList();
                }
            } else {
                let status = await updateActive({
                    id: this.updateActiveId,
                    active: true,
                });
                if (status.code == 403) {
                    this.dialogFail = true;
                    this.dialogStatusActive = false;
                } else {
                    this.dialogStatusActive = false;
                    this.dialogActiveSuccess = true;
                    this.getBannerList();
                }
            }
        },
        cancelStatus() {
            this.dialogStatus = false;
            this.banner[this.indexItem].active = this.updateActive;
        },
        cancelStatusActive() {
            this.dialogStatusActive = false;
            this.banner[this.indexItem].active = this.updateActive;
        },
        async getUserGroupList() {
            let result = await getUserGroup();
            this.groupUsers = [];
            this.arrayUserGroup = [];
            await result.forEach(async (group) => {
                group.child_User_Group.length === 0
                    ? await this.groupUsers.push({
                        title: group.title,
                        _id: group._id,
                    })
                    : null;
                group.child_User_Group.forEach(async (child) => {
                    child.child_User_Group.length === 0
                        ? await this.groupUsers.push({
                            title: group.title + ' -> ' + child.title,
                            _id: child._id,
                        })
                        : null;
                    child.child_User_Group.forEach(async (lastChild) => {
                        await this.groupUsers.push({
                            title:
                                group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
                            _id: lastChild._id,
                        });
                    });
                });
            });
            this.arrayUserGroup = this.groupUsers;
        },
        clearUrl() {
            if (this.url) {
                // this.url = this.url.toLowerCase();
                // let tmphttps = this.url.indexOf("http")
                // if (tmphttps > -1) {
                //     this.url = this.url.replace("https://", "");
                //     this.url = this.url.replace("http://", "");
                // }
                let tempLowerUrl = this.url.toLowerCase();
                let tmphttps = tempLowerUrl.indexOf("http")
                if (tmphttps > -1) {
                    this.url = this.url.replace(/https:[/][/]/gi, '')
                    this.url = this.url.replace(/http:[/][/]/gi, '')
                }

            }
        },
    },
};
